/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PurchaseCostCoverageItemData } from './PurchaseCostCoverageItemData';
import {
    PurchaseCostCoverageItemDataFromJSON,
    PurchaseCostCoverageItemDataFromJSONTyped,
    PurchaseCostCoverageItemDataToJSON,
    PurchaseCostCoverageItemDataToJSONTyped,
} from './PurchaseCostCoverageItemData';

/**
 * 
 * @export
 * @interface PurchaseCostCoverageItemsPageData
 */
export interface PurchaseCostCoverageItemsPageData {
    /**
     * 
     * @type {number}
     * @memberof PurchaseCostCoverageItemsPageData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseCostCoverageItemsPageData
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseCostCoverageItemsPageData
     */
    totalItems?: number;
    /**
     * 
     * @type {Array<PurchaseCostCoverageItemData>}
     * @memberof PurchaseCostCoverageItemsPageData
     */
    items?: Array<PurchaseCostCoverageItemData>;
}

/**
 * Check if a given object implements the PurchaseCostCoverageItemsPageData interface.
 */
export function instanceOfPurchaseCostCoverageItemsPageData(value: object): value is PurchaseCostCoverageItemsPageData {
    return true;
}

export function PurchaseCostCoverageItemsPageDataFromJSON(json: any): PurchaseCostCoverageItemsPageData {
    return PurchaseCostCoverageItemsPageDataFromJSONTyped(json, false);
}

export function PurchaseCostCoverageItemsPageDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseCostCoverageItemsPageData {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'totalItems': json['totalItems'] == null ? undefined : json['totalItems'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(PurchaseCostCoverageItemDataFromJSON)),
    };
}

export function PurchaseCostCoverageItemsPageDataToJSON(json: any): PurchaseCostCoverageItemsPageData {
    return PurchaseCostCoverageItemsPageDataToJSONTyped(json, false);
}

export function PurchaseCostCoverageItemsPageDataToJSONTyped(value?: PurchaseCostCoverageItemsPageData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'pageSize': value['pageSize'],
        'totalItems': value['totalItems'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(PurchaseCostCoverageItemDataToJSON)),
    };
}

